import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar } from 'lucide-react';
import styles from './CustomDatePicker.module.css';

const CustomDatePicker = ({
  selected,
  onChange,
  placeholderText = "Select Date",
  required = false,
  className = "",
  ...props
}) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

  return (
    <div className={`${styles['datepicker-wrapper']} ${className}`}>
      <ReactDatePicker
        selected={selected && !isNaN(new Date(selected).getTime()) ? new Date(selected) : null}
        onChange={(date) => {
          if (date && isNaN(date.getTime())) {
            onChange(null);
          } else {
            onChange(date);
          }
        }}
        placeholderText={placeholderText}
        required={required}
        dateFormat="dd/MM/yyyy"
        showYearDropdown
        showMonthDropdown
        dropdownMode="select"
        className={styles['datepicker-input']}
        calendarClassName={styles['custom-calendar']}
        dayClassName={(date) => styles['custom-day']}
        popperClassName={styles['custom-popper']}
        portalId="root"
        withPortal={isMobile}
        popperProps={{
          positionFixed: true
        }}
        {...props}
      />
      <Calendar className={styles['calendar-icon']} size={18} />
    </div>
  );
};

export default CustomDatePicker;
